// extracted by css-extract-rspack-plugin
export default {"TargetsPanelText":"TargetsPanel-module__TargetsPanelText___SXrGCB","TargetsPanelHeading":"TargetsPanel-module__TargetsPanelHeading___H44bXn"};